import React, { useState, useEffect, useRef } from 'react';
import "./InvoiceDetail.css";
import Cookies from 'js-cookie';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { use } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import PaymentService from "../../components/Service/NeoXService";
import { useNavigate } from "react-router-dom";
import { createPayPal } from '../../components/Service/PaypalService';
import { updateWallet } from "../../components/Service/Transaction";
import useLanguage from '../../Hooks/useLanguage';
import { useTranslation } from 'react-i18next';
//eslint-disable-next-line
import html2pdf from "html2pdf.js";

const InvoiceDetail = () => {
    const baseURL = process.env.REACT_APP_API_URL;

    const navi = useNavigate();
    const [invoiceData, setInvoiceData] = useState(null);
    const { invoiceId } = useParams();
    const [orderdetailID, setorderDetailID] = useState(null);
    const [packageID, setpackageID] = useState(null);
    useLanguage();

    const { t } = useTranslation();
    const data = [
        {
            stt: 1,
            service: "Dịch vụ lưu trữ Cloud Server - Cloud-VM01 vpn2 (09/12/2024 - 08/01/2025)",
            details: [
                "+ RAM [GB]: GB x 1",
                "+ CPU Cores: Core x 1",
                "+ Disk Size [GB]: GB x 20",
                "+ IP Address: IP x 1",
            ],
            unit: "Gói",
            quantity: 1,
            unitPrice: "140,000 đ",
            total: "140,000 đ",
            taxRate: "10%",
            taxAmount: "14,000 đ",
        },
    ];
    const [user, setuser] = useState(null);
    const [orderDetails, setorderDetails] = useState(null);
    const [InvoiceItem, setInvoiceItem] = useState(null);

    const summary = {
        subtotal: "140,000 đ",
        vat: "14,000 đ",
        total: "154,000 đ",
    };
    const fetchInvoiceData = async () => {
        try {
            const token = Cookies.get("Token");
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/invoice/${invoiceId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            console.log("response?.data", response?.data)
            setInvoiceData(response.data.invoice);
            setuser(response?.data?.user)
            setorderDetails(response?.data?.items)
            setInvoiceItem(response?.data?.invoice_item)
            setorderDetailID(response?.data?.order_detail_id)
            setpackageID(response?.data?.items[0]?.invoice_item?.package?.id)
        } catch (err) {
            console.error('Lỗi khi tải dữ liệu hóa đơn:', err);
        }
    };



    console.log("packageID", packageID)


    useEffect(() => {
        fetchInvoiceData();
    }, []);

    // const handleSelectedPay = async () => {
    //     const approvalUrl = await createPayPalOrder(invoiceId, invoiceData?.total);
    //     window.location.href = approvalUrl;

    // }

    const [isLoading, setIsLoading] = useState(false);
    const isUpgrade = invoiceData?.items[0]?.notes?.includes("=>");
    console.log("isUpgrade", isUpgrade)

    const handleSelectedPay = async () => {
        const selectedMethod = document.querySelector('select[name="paymethod"]').value;
        const paymentService = new PaymentService();

        // Bắt đầu loading
        setIsLoading(true);

        try {
            switch (parseInt(selectedMethod)) {
                case 154: // VNPAY
                    if (isUpgrade == true) {
                        const paymentUrl = await paymentService.createPayment(invoiceData?.total, invoiceId, 'CC', "upgrade", String(orderdetailID), packageID);
                        // paymentUrl = await paymentService.createPayment(props?.paymentAmount, invoiceID, 'ATM', "upgrade", props?.order_detailsID, props?.package?.id);

                        if (paymentUrl) {
                            window.location.href = paymentUrl;
                        }
                        break;
                    }
                    else {

                        const paymentUrl = await paymentService.createPayment(invoiceData?.total, invoiceId, 'CC', "createvm", "", 1);

                        if (paymentUrl) {
                            window.location.href = paymentUrl;
                        }
                        break;
                    }


                case 101: // MoMo
                    window.location.href = "/payment/momo";
                    break;

                case 234: // PayPal Checkout
                    if (isUpgrade == true) {
                        const paymentUrl = await paymentService.createPayment(invoiceData?.total, invoiceId, 'ATM', "upgrade", String(orderdetailID), packageID);
                        // paymentUrl = await paymentService.createPayment(props?.paymentAmount, invoiceID, 'ATM', "upgrade", props?.order_detailsID, props?.package?.id);

                        if (paymentUrl) {
                            window.location.href = paymentUrl;
                        }
                        break;
                    }
                    else {
                        const paymentUrl = await paymentService.createPayment(invoiceData?.total, invoiceId, 'ATM', "createvm", "", 1);
                        if (paymentUrl) {
                            window.location.href = paymentUrl;
                        }
                        break;
                    }

                case 130: // PayPal

                    if (isUpgrade == true) {
                        const paymentUrl = await paymentService.createPayment(invoiceId, invoiceData?.total, "upgrade", orderdetailID, packageID);
                        // paymentUrl = await paymentService.createPayment(props?.paymentAmount, invoiceID, 'ATM', "upgrade", props?.order_detailsID, props?.package?.id);

                        if (paymentUrl) {
                            window.location.href = paymentUrl;
                        }
                        break;
                    }
                    else {
                        const paymentUrl = await createPayPal(invoiceId, invoiceData?.total, "Tạo VM", 1, 1, "");
                        if (paymentUrl) {
                            window.location.href = paymentUrl;
                        }
                        break;
                    }




                case 8: // QR Payment
                    if (isUpgrade == true) {
                        const paymentUrl = await paymentService.createPayment(invoiceData?.total, invoiceId, 'QR', "upgrade", String(orderdetailID), packageID);
                        // paymentUrl = await paymentService.createPayment(props?.paymentAmount, invoiceID, 'ATM', "upgrade", props?.order_detailsID, props?.package?.id);

                        if (paymentUrl) {
                            window.location.href = paymentUrl;
                        }
                        break;
                    }
                    else {
                        const paymentUrl = await paymentService.createPayment(invoiceData?.total, invoiceId, 'QR', "createvm", "", 1);
                        if (paymentUrl) {
                            window.location.href = paymentUrl;
                        }
                        break;
                    }

                case 10: // QR Payment
                    navi('/thank-you/bank', { state: { invoiceId } });
                    window.location.href = '/thank-you/bank';

                    break;

                case 12: // wallet
                    if (isUpgrade == true) {
                        const updateTaoVM = async () => {
                            try {
                                const data = await updateWallet(invoiceData?.total);
                                console.log("Wallet updated successfully:", data);

                                const transactionResponse = await fetch(`${baseURL}/api/v1/create-transaction`, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        "Authorization": `Bearer ${Cookies.get("Token")}`
                                    },
                                    body: JSON.stringify({
                                        status: 1,
                                        invoiceId: invoiceId,
                                        amount: invoiceData?.total,
                                        gatewayId: 3,
                                        type: 1,
                                    }),
                                });

                                if (!transactionResponse.ok) throw new Error("Failed to save transaction.");
                                const transactionResult = await transactionResponse.json();
                                console.log("Transaction saved successfully", transactionResult);

                                const paymentResponse = await fetch(`${baseURL}/api/v1/update-payment`, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        "Authorization": `Bearer ${Cookies.get("Token")}`
                                    },
                                    body: JSON.stringify({
                                        status: "COMPLETED",
                                        invoiceId: invoiceId,
                                        paymentMethod: "wallet"
                                    }),
                                });

                                if (!paymentResponse.ok) throw new Error("Failed to update payment.");
                                const paymentResult = await paymentResponse.json();
                                console.log("Payment updated successfully", paymentResult);

                                window.location.href = '/thank-you/bank';
                            } catch (error) {
                                console.error("Error updating wallet:", error);
                            }
                        };
                        updateTaoVM();
                    } else {
                        const updateTaoVM = async () => {

                            try {
                                const data = await updateWallet(invoiceData?.total);
                                console.log("Wallet updated successfully:", data);

                                const transactionResponse = await fetch(`${baseURL}/api/v1/create-transaction`, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        "Authorization": `Bearer ${Cookies.get("Token")}`
                                    },
                                    body: JSON.stringify({
                                        status: 1,
                                        invoiceId: invoiceId,
                                        amount: invoiceData?.total,
                                        gatewayId: 3,
                                        type: 1,
                                    }),
                                });

                                if (!transactionResponse.ok) throw new Error("Failed to save transaction.");
                                const transactionResult = await transactionResponse.json();
                                console.log("Transaction saved successfully", transactionResult);

                                const paymentResponse = await fetch(`${baseURL}/api/v1/update-payment`, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        "Authorization": `Bearer ${Cookies.get("Token")}`
                                    },
                                    body: JSON.stringify({
                                        status: "COMPLETED",
                                        invoiceId: invoiceId,
                                        paymentMethod: "wallet"
                                    }),
                                });

                                if (!paymentResponse.ok) throw new Error("Failed to update payment.");
                                const paymentResult = await paymentResponse.json();
                                console.log("Payment updated successfully", paymentResult);

                                window.location.href = '/thank-you/bank';
                            } catch (error) {
                                console.error("Error updating wallet:", error);
                            }
                        };
                        updateTaoVM();

                    }



                    break;

                default:
                    alert("Vui lòng chọn phương thức thanh toán hợp lệ!");
                    setIsLoading(false);
            }
        } catch (error) {
            console.error("Lỗi thanh toán:", error);
            setIsLoading(false);
        }
    };
    const invoiceRef = useRef();
    const handlePrintPDF = async () => {
        const element = invoiceRef.current;

        html2pdf()
            .from(element)
            .set({
                filename: 'invoice.pdf',
                html2canvas: { scale: 2 },
                jsPDF: { format: 'a4', orientation: 'portrait' },
                pagebreak: { mode: 'avoid-all' },
            })
            .toPdf()
            .get('pdf')
            .then((pdf) => {
                if (pdf.internal.getNumberOfPages() > 1) {
                    // pdf.deletePage(2);
                }
                pdf.save('invoice.pdf');
            });
    };
    const LoadingSpinner = () => (
        <div className="loading-overlay">
            <div className="spinner"></div>
        </div>
    );

    const [colorButton, setColorButton] = useState("green");
    const [textColor, setTextColor] = useState("white");
    const [isDisabled, setIsDisabled] = useState(false);

    const handleConfirmBank = () => {
        setColorButton("gray");
        setTextColor("white");
        setIsDisabled(true);
    };

    const banks = [
        {
            name: 'Techcombank',
            branch: 'Chi nhánh Kỳ Hòa - TP Hồ Chí Minh',
            accountNumber: '63096868',
            accountName: 'CÔNG TY TNHH TIDADIGI',
            transferNote: `Thanh toan don hang ${invoiceData?.invoice_number}`,
            qrImage: 'https://cms.qrgateway.com/storage/posts/February2024/_0ff5b93f-baef-4f24-99a1-f110caf48aee.jpg' // Đường dẫn ảnh QR
        }
    ];


    const statusColors = {
        0: "#FFC107",
        1: "#28A745",
        2: "#6C757D",
        4: "#DC3545",
        5: "#17A2B8",
        6: "#FD7E14",
        7: "#FF5733"
    };

    return (
        <>
            <div className="body-content">

                <div className="px-2 py-2 mx-4 mb-4 justify-content-between">
                    <h2 style={{ color: "#0069ff" }} className="mb-0">{t("Invoice")} {invoiceData?.invoice_number}</h2>
                    <div className="mb-4">
                        <a href="/invoice" className="btn-link my-5">
                            <small>{t("ViewIV")}</small>
                        </a>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <div className="mb-3 mb-md-0">
                                <span
                                    style={{
                                        fontSize: "15px",
                                        color: statusColors[invoiceData?.status] || "#6C757D",
                                    }}
                                >

                                    {(() => {
                                        switch (invoiceData?.status) {
                                            case 0:
                                                return t("Unpaid");
                                            case 1:
                                                return t("Paid");
                                            case 2:
                                                return t("Draft");
                                            case 3:
                                                return t("Cancelled");
                                            case 4:
                                                return t("Refunded");
                                            case 5:
                                                return t("Collections");
                                            case 6:
                                                return t("Overdue");
                                            default:
                                                return "Không xác định";
                                        }
                                    })()}
                                </span>


                                {(invoiceData?.status === 1 || invoiceData?.status === 5) && invoiceData?.paid_date && (
                                    <span className="badge badge-light text-secondary px-3 py-2">
                                        {new Date(invoiceData?.paid_date).toLocaleString("vi-VN")}
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className='col-2 '>

                        </div>
                        <div className="col-4 d-flex justify-content-end">
                            <div className="">
                                {invoiceData?.status == 0 ?
                                    (
                                        <a
                                            style={{
                                                background: "#0069ff",
                                                color: "white",
                                                padding: "10px 20px",
                                                border: "none",
                                                borderRadius: "5px",
                                                cursor: "pointer"
                                            }}
                                            className="btn btn-sm btn-secondary btn_pdf mr-2 my-2 my-md-0"

                                            data-toggle="modal"
                                            aria-expanded="false"
                                            data-target="#payInvoiceModal"
                                        >
                                            {t("Payment")}!
                                        </a>

                                    ) : ""

                                }
                                <a
                                    style={{
                                        background: "gray",
                                        color: "white",
                                        padding: "10px 20px",
                                        border: "none",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                        marginRight: "10px"
                                    }}
                                    className="btn btn-sm btn-secondary btn_pdf mr-2 my-2 my-md-0"
                                    onClick={handlePrintPDF}
                                >
                                    {t("Download PDF file")}
                                </a>
                                {/* 
                                <a
                                    style={{
                                        background: "gray",
                                        color: "white",
                                        padding: "10px 20px",
                                        border: "none",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                        marginRight: "10px"
                                    }}
                                    className="btn btn-sm btn-secondary btn_pdf mr-2 my-2 my-md-0"
                                    target="_blank"
                                    href="root&action=download&invoice=57253"
                                >
                                    // <i className="material-icons icon-btn-color mr-2 size-sm notranslate">
                                    //     picture_as_pdf
                                    // </i>
                                    In hóa đơn
                                </a> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="modal fade fade2"
                    id="payInvoiceModal"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title font-weight-bold mt-2">{t("Payment")}!</h4>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <i className="">{t("Cancel")}</i>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form action="" method="post" className="pb-4">
                                    <select name="paymethod" className="form-control w-100">
                                        <option value={154} selected="selected">
                                            VISA
                                        </option>
                                        {/* <option value={101}>Ví điện tử MoMo</option> */}
                                        <option value={234}>ATM</option>
                                        <option value={130}>Paypal</option>
                                        <option value={8}>QR</option>
                                        <option value={10}>{t("Bank transfer")}</option>
                                        <option value={12}>{t("Balance")}</option>

                                    </select>
                                    <input
                                        type="hidden"
                                        name="security_token"
                                        defaultValue="f6f2f56f67ad04c9d0f0dab477425958"
                                    />
                                </form>
                                <div className="w-100 my-2">
                                    <div
                                        id="gateway"
                                        className="d-flex flex-column justify-content-center"
                                    >
                                        <div style={{ position: "relative", width: "150px", margin: "0px auto" }}>
                                            <a
                                                onClick={handleSelectedPay}
                                                disabled={isLoading}
                                                className="btn btn-primary"
                                                style={{ color: "white", width: "100%", position: "relative" }}
                                            >
                                                {!isLoading && "Thanh toán"}
                                            </a>
                                            {isLoading && (
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "50%",
                                                        transform: "translate(-50%, -50%)",
                                                    }}
                                                >
                                                    <LoadingSpinner />
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="info-box">

                </div>
            </div>
            <div style={{ border: "1px solid #B7AEAE", borderRadius: "5px", marginLeft: "30px", marginRight: "30px" }}>
                <div ref={invoiceRef} id="printView" style={{ position: "relative" }}>
                    <div className="VATTEMP">
                        <div id="quantitypages" style={{ paddingLeft: 0 }}>
                            <div className="page_a4">
                                <div id="1" className="pagecurrent">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td
                                                    className="logo"
                                                    style={{ width: "150px", borderBottom: "1px solid #ccc" }}
                                                >
                                                    <svg width="100%" height="100%" viewBox="37 85 1276 319" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M37 85H726V404H37V85Z" fill="#F2721E"></path><path d="M726 85H1313V404H726V85Z" fill="#040053"></path><path d="M161.5 332V185.5H106V157H248V185.5H192.5V332H161.5Z" fill="white"></path><path d="M282.359 332V157H313.109V332H282.359Z" fill="white"></path><path d="M359.955 332V157H425.205C480.205 157 518.205 194.75 518.205 244V244.5C518.205 293.75 480.205 332 425.205 332H359.955ZM390.705 304H425.205C461.955 304 485.955 279.25 485.955 245V244.5C485.955 210.25 461.955 185 425.205 185H390.705V304Z" fill="white"></path><path d="M528.549 332L605.5 157H634L711.049 332H678.549L660.799 289.75H578.049L560.049 332H528.549ZM589.299 262.5H649.549L619.299 192.5L589.299 262.5Z" fill="white"></path><path d="M741.059 332V157H806.309C861.309 157 899.309 194.75 899.309 244V244.5C899.309 293.75 861.309 332 806.309 332H741.059ZM771.809 304H806.309C843.059 304 867.059 279.25 867.059 245V244.5C867.059 210.25 843.059 185 806.309 185H771.809V304Z" fill="white"></path><path d="M938.365 332V157H969.115V332H938.365Z" fill="white"></path><path d="M1098.96 335C1044.21 335 1008.21 296 1008.21 245V244.5C1008.21 195.5 1045.71 154 1098.46 154C1128.96 154 1147.71 162.5 1165.71 177.75L1146.21 201C1132.71 189.5 1119.46 182.25 1097.21 182.25C1064.96 182.25 1040.46 210.5 1040.46 244V244.5C1040.46 280.5 1064.21 307 1099.96 307C1116.46 307 1131.46 301.75 1142.21 293.75V261H1097.46V234.25H1171.96V307.75C1154.71 322.5 1129.96 335 1098.96 335Z" fill="white"></path><path d="M1213.76 332V157H1244.51V332H1213.76Z" fill="white"></path></svg>
                                                </td>
                                                <td style={{ borderBottom: "1px solid #ccc" }}>
                                                    <table style={{ width: "100%", height: "108px" }}>
                                                        <tbody>
                                                            <tr
                                                                className="vertical-align-top"
                                                                style={{ height: "18px" }}
                                                            >
                                                                <td style={{ height: "20px" }} colSpan="2">
                                                                    <strong style={{ fontWeight: "bold" }}>
                                                                        CÔNG TY TNHH TIDADIGI

                                                                    </strong>
                                                                </td>
                                                            </tr>
                                                            <tr
                                                                className="vertical-align-top"
                                                                style={{ height: "18px" }}
                                                            >
                                                                <td style={{ height: "18px" }} colSpan="2">
                                                                    {t("Tax code")}:{" "}
                                                                    <label
                                                                        className="fl-l input-name"
                                                                        style={{ fontWeight: "bold" }}
                                                                    >
                                                                        0318667211
                                                                    </label>
                                                                </td>
                                                            </tr>
                                                            <tr
                                                                className="vertical-align-top"
                                                                style={{ height: "36px" }}
                                                            >
                                                                <td
                                                                    style={{ verticalAlign: "top", height: "44px" }}
                                                                    colSpan="2"
                                                                >
                                                                    {t("Address")}:
                                                                    <span className="fl-l input-name"> 711 An Dương Vương, Phường Bình Trị Đông, Quận Bình Tân, Thành Phố Hồ Chí Minh, Việt Nam.
                                                                    </span>
                                                                </td>

                                                            </tr>
                                                            <tr
                                                                className="vertical-align-top"
                                                                style={{ height: "18px" }}
                                                            >
                                                                <td style={{ height: "18px" }}>
                                                                    {t("Phone number")}:{" "}
                                                                    <label className="fl-l input-name">
                                                                        0918245138
                                                                    </label>
                                                                </td>
                                                            </tr>
                                                            <tr
                                                                className="vertical-align-top"
                                                                style={{ height: "18px" }}
                                                            >
                                                                <td style={{ height: "18px" }}>
                                                                    {t("Account number")}: 63096868 tại Ngân hàng Techcombank
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div className=" py-4" style={{ height: "100px" }}>
                                        <table style={{ width: "100%" }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ textAlign: "left" }}>
                                                        <h2
                                                            style={{
                                                                textTransform: "uppercase",
                                                                margin: 0,
                                                                fontWeight: "bold",
                                                                fontSize: "22px",
                                                                marginBottom: 0,
                                                            }}
                                                        >
                                                            {t("Invoice")}
                                                        </h2>
                                                        <p style={{ fontStyle: "italic", margin: 0 }}>
                                                            {t("Invoice")}{invoiceData?.invoice_number}
                                                        </p>
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        <p
                                                            style={{
                                                                fontWeight: "bold",
                                                                fontSize: "13px",
                                                                marginTop: 0,
                                                                marginBottom: 0,
                                                            }}
                                                        >
                                                            {t("Status")}:{" "}
                                                            <span
                                                                style={{
                                                                    fontSize: "15px",
                                                                    color: statusColors[invoiceData?.status] || "#6C757D", // Mặc định là xám nhạt nếu không xác định
                                                                }}
                                                            >
                                                                {(() => {
                                                                    switch (invoiceData?.status) {
                                                                        case 0:
                                                                            return t("Unpaid");
                                                                        case 1:
                                                                            return t("Paid");
                                                                        case 2:
                                                                            return t("Draft");
                                                                        case 3:
                                                                            return t("Cancelled");
                                                                        case 4:
                                                                            return t("Refunded");
                                                                        case 5:
                                                                            return t("Collections");
                                                                        case 6:
                                                                            return t("Overdue");
                                                                        default:
                                                                            return "Không xác định";
                                                                    }
                                                                })()}
                                                            </span>

                                                        </p>

                                                        <p
                                                            style={{
                                                                fontWeight: "bold",
                                                                fontSize: "13px",
                                                                marginBottom: 0,
                                                                marginTop: 0,
                                                            }}
                                                        >

                                                            <span
                                                                className="number"
                                                                style={{ fontSize: "13px", fontStyle: "italic" }}
                                                            >
                                                                {t("Creation date")}:  {invoiceData?.created_at
                                                                    ? new Date(invoiceData?.created_at).toLocaleDateString('vi-VN')
                                                                    : '-'}
                                                            </span>
                                                        </p>
                                                        <p
                                                            style={{
                                                                fontWeight: "bold",
                                                                fontSize: "13px",
                                                                marginBottom: 0,
                                                                marginTop: 0,
                                                            }}
                                                        >
                                                            {t("Payment term")}:{" "}
                                                            <span
                                                                className="number"
                                                                style={{ fontSize: "13px", fontStyle: "italic" }}
                                                            >
                                                                {invoiceData?.due_date
                                                                    ? new Date(invoiceData?.due_date).toLocaleDateString('vi-VN')
                                                                    : '-'}
                                                            </span>
                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <table style={{ marginTop: "5px", width: "100%", overflow: "hidden" }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ borderTop: "1px solid #ccc" }}>
                                                    <table style={{ width: "100%" }}>
                                                        <tbody>
                                                            <tr className="vertical-align-top">
                                                                <td colSpan="2">
                                                                    {t("Name buyer")}: {user?.name}
                                                                </td>
                                                            </tr>
                                                            <tr className="vertical-align-top">
                                                                <td colSpan="2">
                                                                    {t("Unit name")}: {user?.name_company}
                                                                </td>
                                                            </tr>
                                                            <tr className="vertical-align-top">
                                                                <td colSpan="2">
                                                                    {t("Tax code")}: {user?.taxcode}
                                                                </td>
                                                            </tr>
                                                            <tr className="vertical-align-top">
                                                                <td colSpan="2">
                                                                    {t("Address")}: {user?.address}
                                                                    <label className="fl-l input-name">
                                                                    </label>
                                                                </td>
                                                            </tr>
                                                            <tr className="vertical-align-top">
                                                                <td>
                                                                    {t("Payment method")}: {invoiceData?.payment_method}
                                                                    <label className="fl-l input-name">
                                                                    </label>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div className="statistics">
                                        <table
                                            className="table"
                                            style={{
                                                width: "100%",
                                                marginTop: "10px",
                                                borderCollapse: "collapse",
                                            }}
                                        >
                                            <thead>
                                                <tr style={{ height: "35px", borderBottom: "1px solid black" }}>
                                                    <th
                                                        style={{
                                                            textAlign: "center",
                                                            width: "20px",
                                                            border: "1px solid black",
                                                        }}
                                                    >
                                                        STT
                                                    </th>
                                                    <th
                                                        style={{
                                                            textAlign: "center",
                                                            border: "1px solid black",
                                                        }}
                                                    >
                                                        {t("Products/Services")}
                                                    </th>
                                                    <th
                                                        style={{
                                                            textAlign: "center",
                                                            width: "60px",
                                                            border: "1px solid black",
                                                        }}
                                                    >
                                                        {t("Unit of calculation")}
                                                    </th>
                                                    <th
                                                        style={{
                                                            textAlign: "center",
                                                            width: "100px",
                                                            border: "1px solid black",
                                                        }}
                                                    >
                                                        {t("Quantity")}
                                                    </th>
                                                    <th
                                                        style={{
                                                            textAlign: "center",
                                                            width: "50px",
                                                            border: "1px solid black",
                                                        }}
                                                    >
                                                        {t("Price")}
                                                    </th>

                                                    <th
                                                        style={{
                                                            textAlign: "center",
                                                            width: "100px",
                                                            border: "1px solid black",
                                                        }}
                                                    >
                                                        {t("Tax")}
                                                    </th>
                                                    <th
                                                        style={{
                                                            textAlign: "center",
                                                            width: "100px",
                                                            border: "1px solid black",
                                                        }}
                                                    >
                                                        {t("Amount")}
                                                    </th>
                                                    {/* <th
                                                        style={{
                                                            textAlign: "center",
                                                            width: "100px",
                                                            border: "1px solid black",
                                                        }}
                                                    >
                                                        Tiền Thuế GTGT
                                                    </th> */}

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {orderDetails && orderDetails.length > 0 ? (
                                                    orderDetails.map((item, index) => (
                                                        <tr key={index}>
                                                            <td
                                                                align="center"
                                                                style={{ border: "1px solid black" }}
                                                            >
                                                                {index + 1}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    border: "1px solid black",
                                                                    padding: "5px",
                                                                    fontSize: "13px",
                                                                    whiteSpace: "normal", // Đảm bảo xuống dòng
                                                                }}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: `${item.invoice_item?.des?.replace(/\n/g, "<br>") || ""} `
                                                                }}
                                                            ></td>



                                                            <td
                                                                align="center"
                                                                style={{ border: "1px solid black" }}
                                                            >
                                                                {t("Plan")}
                                                            </td>
                                                            <td
                                                                align="center"
                                                                style={{ border: "1px solid black" }}
                                                            >
                                                                1
                                                            </td>
                                                            <td
                                                                align="center"
                                                                style={{ border: "1px solid black" }}
                                                            >
                                                                {item?.invoice_item?.sub_total && new Intl.NumberFormat('vi-VN', {}).format(item.invoice_item.sub_total)}đ
                                                            </td>

                                                            <td
                                                                align="center"
                                                                style={{ border: "1px solid black" }}
                                                            >
                                                                {item?.invoice_item?.taxed == 0 ? "10%" : "0"}
                                                            </td>
                                                            <td
                                                                align="right"
                                                                style={{ border: "1px solid black" }}
                                                            >
                                                                {item?.invoice_item?.total?.toLocaleString("vi-VN")}đ
                                                            </td>
                                                            {/* <td
                                                                align="center"
                                                                style={{ border: "1px solid black" }}
                                                            >
                                                                {item?.invoice_item?.tax?.toLocaleString("vi-VN")}
                                                            </td> */}


                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td
                                                            colSpan="8"
                                                            align="center"
                                                            style={{ border: "1px solid black" }}
                                                        >
                                                            Không có chi tiết đơn hàng nào.
                                                        </td>
                                                    </tr>
                                                )}
                                                <tr>
                                                    <td colSpan="6" align="right" style={{
                                                        border: "1px solid black",
                                                    }}>
                                                        <b>{t("Subtotal")}:</b>

                                                    </td>
                                                    <td
                                                        colSpan="2"
                                                        align="right"
                                                        style={{
                                                            border: "1px solid black",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {invoiceData?.sub_total
                                                            ? Number(invoiceData?.sub_total).toLocaleString("vi-VN")
                                                            : "0"}đ
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="6" align="right" style={{
                                                        border: "1px solid black",
                                                        fontWeight: "bold",
                                                    }}>
                                                        <b>{t("Tax")} VAT:</b>

                                                    </td>
                                                    <td
                                                        colSpan="2"
                                                        align="right"
                                                        style={{
                                                            border: "1px solid black",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {invoiceData?.tax
                                                            ? Number(invoiceData?.tax).toLocaleString("vi-VN")
                                                            : "0"}đ
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="6" align="right" style={{
                                                        border: "1px solid black",
                                                        fontWeight: "bold",
                                                    }}>
                                                        <strong>{t("Total Amount")}:</strong>

                                                    </td>
                                                    <td
                                                        colSpan="2"
                                                        align="right"
                                                        style={{
                                                            border: "1px solid black",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {invoiceData?.total
                                                            ? Number(invoiceData.total).toLocaleString("vi-VN")
                                                            : "0"}đ
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div className="clearfix">
                                            <center style={{ marginBottom: 50 }}>
                                                <table style={{ width: "100%", height: 100 }}>
                                                    <tbody>
                                                        <tr>
                                                            <td
                                                                style={{
                                                                    border: "none",
                                                                    width: 250,
                                                                    verticalAlign: "top",
                                                                    textAlign: "center"
                                                                }}
                                                            >
                                                                <p style={{ fontSize: 14, marginTop: 10, marginBottom: 0 }}>
                                                                    <strong> {t("Buyer")} </strong>
                                                                </p>
                                                                <em>({t("Signature, full name")})</em>
                                                            </td>
                                                            <td
                                                                style={{
                                                                    border: "none",
                                                                    width: 250,
                                                                    verticalAlign: "top",
                                                                    textAlign: "center"
                                                                }}
                                                            >
                                                                &nbsp;
                                                            </td>
                                                            <td
                                                                style={{
                                                                    border: "none",
                                                                    width: 250,
                                                                    verticalAlign: "top",
                                                                    textAlign: "center"
                                                                }}
                                                            >
                                                                <p style={{ fontSize: 14, marginTop: 10, marginBottom: 0 }}>
                                                                    <strong> {t("Seller")} </strong>
                                                                </p>
                                                                <em>({t("Signature, seal, full name")})</em>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </center>
                                            <div>
                                                <div style={{ textAlign: "center", paddingTop: 5 }}>&nbsp;</div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {invoiceData?.payment_method === "bank" && (
                    <>
                        <div className="payment-notice">
                            <p>
                                <strong>⚠ Đơn hàng chỉ hoàn thành khi Quý khách đã chuyển tiền cho TIDADIGI.</strong>
                                Quý khách vui lòng chuyển khoản theo nội dung <strong>Thanh toán đơn hàng số: {invoiceData?.invoice_number}</strong> trong nội dung thanh toán tới TIDA theo một trong các danh sách ngân hàng dưới đây.
                            </p>
                        </div>

                        <table className="bank-table">
                            <thead>
                                <tr>
                                    <th>Ngân hàng</th>
                                    <th>Logo</th>
                                    <th>Số tài khoản</th>
                                    <th>Chủ tài khoản</th>
                                    <th>Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {banks.map((bank, index) => (
                                    <tr key={index}>
                                        <td>{bank.name}</td>
                                        <td>
                                            <img
                                                src={bank.name === 'Vietcombank'
                                                    ? '/images/vietcombank-logo.png'
                                                    : 'https://upload.wikimedia.org/wikipedia/commons/7/7c/Techcombank_logo.png'}
                                                alt={`${bank.name} logo`}
                                                style={{ height: "30px" }}
                                            />
                                        </td>
                                        <td>{bank.accountNumber}</td>
                                        <td>{bank.accountName}</td>
                                        <td>
                                            <button
                                                style={{
                                                    backgroundColor: colorButton,
                                                    color: textColor,
                                                    border: "none",
                                                    borderRadius: "5px",
                                                    cursor: isDisabled ? "not-allowed" : "pointer",
                                                    opacity: isDisabled ? 0.6 : 1,
                                                }}
                                                onClick={handleConfirmBank}
                                                disabled={isDisabled}
                                            >
                                                Đã chuyển khoản
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </>
                )}
            </div>
        </>

    );
};

export default InvoiceDetail;
